import React from "react";
import { useTranslation } from "react-i18next";
import "./AppFooter.css";

const AppFooter = () => {
  const { t, i18n } = useTranslation();
  const isFrench = i18n.language?.toLowerCase().startsWith("fr");
  const renotrendBase = isFrench ? "https://renotrend.com/fr-CA" : "https://renotrend.com";
  const facadeAiUrl = isFrench ? "https://facadeai.app/fr/" : "https://facadeai.app/";

  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <div className="app-footer-brand">
          <div className="app-footer-product">Facade Web App</div>
          <p>{t("appFooter.description")}</p>
          <a href={`${renotrendBase}/`} className="app-footer-renotrend">
            {t("appFooter.renotrendAssociation")}
          </a>
        </div>

        <nav className="app-footer-column" aria-label={t("appFooter.productLinks")}>
          <h2>{t("appFooter.productLinks")}</h2>
          <a href="#how-it-works">{t("appFooter.howItWorks")}</a>
          <a href="#pricing">{t("appFooter.pricing")}</a>
          <a href="#faq">{t("appFooter.faq")}</a>
          <a href="#contact">{t("appFooter.contact")}</a>
        </nav>

        <nav className="app-footer-column" aria-label={t("appFooter.familyLinks")}>
          <h2>{t("appFooter.familyLinks")}</h2>
          <a href={`${renotrendBase}/`}>RenoTrend</a>
          <a href={facadeAiUrl}>Facade AI</a>
          <a href={`${renotrendBase}/compare`}>{t("appFooter.compareTools")}</a>
        </nav>

        <nav className="app-footer-column" aria-label={t("appFooter.legalLinks")}>
          <h2>{t("appFooter.legalLinks")}</h2>
          <a href="/app/terms">{t("appFooter.terms")}</a>
          <a href="/app/cookies">{t("appFooter.cookies")}</a>
          <a href={`${renotrendBase}/privacy`}>{t("appFooter.privacy")}</a>
        </nav>
      </div>

      <div className="app-footer-bottom">
        <span>© {new Date().getFullYear()} Applications RenoTrend Inc.</span>
        <span>{t("appFooter.productStatement")}</span>
      </div>
    </footer>
  );
};

export default AppFooter;
